export type TabFieldError = {
  name?: (string | number) | (string | number)[];
  errors?: string[];
};

const topLevelName = (name: TabFieldError['name']): string =>
  String(Array.isArray(name) ? name[0] : name);

export const getRejectedFields = (error: unknown): TabFieldError[] =>
  (error as { errorFields?: TabFieldError[] })?.errorFields ?? [];

export const makeTabFieldErrorHelpers = <Tab extends string>(
  tabFieldsByTab: Record<Tab, readonly string[]>
) => {
  const allMappedFields = new Set<string>(
    Object.keys(tabFieldsByTab).flatMap((tab) => tabFieldsByTab[tab as Tab])
  );

  const isActiveTabError = (field: TabFieldError, activeTab: Tab): boolean => {
    if ((field.errors?.length ?? 0) === 0) {
      return false;
    }

    const name = topLevelName(field.name);

    return (
      tabFieldsByTab[activeTab].includes(name) || !allMappedFields.has(name)
    );
  };

  return {
    activeTabHasFieldError: (
      fields: TabFieldError[],
      activeTab: Tab
    ): boolean => fields.some((field) => isActiveTabError(field, activeTab)),

    getFirstActiveTabErrorField: (
      fields: TabFieldError[],
      activeTab: Tab
    ): TabFieldError['name'] | undefined =>
      fields.find((field) => isActiveTabError(field, activeTab))?.name,
  };
};
